/** Países con indicativo telefónico (prioridad Latinoamérica + principales mercados). */
export const PHONE_COUNTRIES = [
  { code: 'CO', name: 'Colombia', dial: '57', flag: '🇨🇴' },
  { code: 'MX', name: 'México', dial: '52', flag: '🇲🇽' },
  { code: 'AR', name: 'Argentina', dial: '54', flag: '🇦🇷' },
  { code: 'CL', name: 'Chile', dial: '56', flag: '🇨🇱' },
  { code: 'PE', name: 'Perú', dial: '51', flag: '🇵🇪' },
  { code: 'EC', name: 'Ecuador', dial: '593', flag: '🇪🇨' },
  { code: 'VE', name: 'Venezuela', dial: '58', flag: '🇻🇪' },
  { code: 'BO', name: 'Bolivia', dial: '591', flag: '🇧🇴' },
  { code: 'PY', name: 'Paraguay', dial: '595', flag: '🇵🇾' },
  { code: 'UY', name: 'Uruguay', dial: '598', flag: '🇺🇾' },
  { code: 'BR', name: 'Brasil', dial: '55', flag: '🇧🇷' },
  { code: 'CR', name: 'Costa Rica', dial: '506', flag: '🇨🇷' },
  { code: 'PA', name: 'Panamá', dial: '507', flag: '🇵🇦' },
  { code: 'GT', name: 'Guatemala', dial: '502', flag: '🇬🇹' },
  { code: 'HN', name: 'Honduras', dial: '504', flag: '🇭🇳' },
  { code: 'SV', name: 'El Salvador', dial: '503', flag: '🇸🇻' },
  { code: 'NI', name: 'Nicaragua', dial: '505', flag: '🇳🇮' },
  { code: 'DO', name: 'Rep. Dominicana', dial: '1809', flag: '🇩🇴' },
  { code: 'PR', name: 'Puerto Rico', dial: '1787', flag: '🇵🇷' },
  { code: 'US', name: 'Estados Unidos', dial: '1', flag: '🇺🇸' },
  { code: 'CA', name: 'Canadá', dial: '1', flag: '🇨🇦' },
  { code: 'ES', name: 'España', dial: '34', flag: '🇪🇸' },
  { code: 'PT', name: 'Portugal', dial: '351', flag: '🇵🇹' },
  { code: 'FR', name: 'Francia', dial: '33', flag: '🇫🇷' },
  { code: 'DE', name: 'Alemania', dial: '49', flag: '🇩🇪' },
  { code: 'IT', name: 'Italia', dial: '39', flag: '🇮🇹' },
  { code: 'GB', name: 'Reino Unido', dial: '44', flag: '🇬🇧' },
  { code: 'NL', name: 'Países Bajos', dial: '31', flag: '🇳🇱' },
  { code: 'CH', name: 'Suiza', dial: '41', flag: '🇨🇭' },
  { code: 'AU', name: 'Australia', dial: '61', flag: '🇦🇺' },
  { code: 'NZ', name: 'Nueva Zelanda', dial: '64', flag: '🇳🇿' },
  { code: 'JP', name: 'Japón', dial: '81', flag: '🇯🇵' },
  { code: 'KR', name: 'Corea del Sur', dial: '82', flag: '🇰🇷' },
  { code: 'CN', name: 'China', dial: '86', flag: '🇨🇳' },
  { code: 'IN', name: 'India', dial: '91', flag: '🇮🇳' },
  { code: 'ZA', name: 'Sudáfrica', dial: '27', flag: '🇿🇦' },
  { code: 'AE', name: 'Emiratos Árabes', dial: '971', flag: '🇦🇪' },
  { code: 'IL', name: 'Israel', dial: '972', flag: '🇮🇱' },
  { code: 'TR', name: 'Turquía', dial: '90', flag: '🇹🇷' },
  { code: 'RU', name: 'Rusia', dial: '7', flag: '🇷🇺' },
];

const DIAL_CODES_DESC = [...new Set(PHONE_COUNTRIES.map((c) => c.dial))].sort(
  (a, b) => b.length - a.length,
);

export const DEFAULT_PHONE_DIAL = '57';

export function digitsOnly(phone) {
  return String(phone || '').replace(/\D/g, '');
}

/** Separa un número guardado en indicativo + número nacional. */
export function parsePhoneValue(value, defaultDial = DEFAULT_PHONE_DIAL) {
  const digits = digitsOnly(value);
  if (!digits) return { dialCode: defaultDial, national: '' };

  for (const dial of DIAL_CODES_DESC) {
    if (!digits.startsWith(dial)) continue;
    const national = digits.slice(dial.length);
    if (national.length >= 4 || national.length === 0) {
      return { dialCode: dial, national };
    }
  }

  // Compatibilidad: celular colombiano de 10 dígitos sin indicativo
  if (digits.length === 10 && digits.startsWith('3')) {
    return { dialCode: '57', national: digits };
  }

  return { dialCode: defaultDial, national: digits };
}

/** Combina indicativo y número nacional en dígitos E.164 sin "+". */
export function combinePhone(dialCode, national) {
  const dial = digitsOnly(dialCode);
  const local = digitsOnly(national).replace(/^0+/, '');
  if (!local) return '';
  if (!dial) return local;
  return `${dial}${local}`;
}

export function formatPhoneDisplay(value, defaultDial = DEFAULT_PHONE_DIAL) {
  const { dialCode, national } = parsePhoneValue(value, defaultDial);
  if (!national) return '';
  return `+${dialCode} ${national}`;
}

export function countryByDial(dial) {
  return PHONE_COUNTRIES.find((c) => c.dial === String(dial)) || null;
}
